const getters = {
  scHolidays: state => state.sc_holidays,
  scHoliday: state => state.sc_holiday,
  scHolidayFilters: state => state.sc_holiday_filters,
}

export default getters;
